import { createContext, useContext } from 'react';

export const ChatNotificationsContext = createContext({ refreshUnseenCount: () => {} });

export const useChatNotifications = () => useContext(ChatNotificationsContext);
